var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialLedgerReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.open_een{fill:#0B1719;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "open_een",
    cx: 11.5,
    cy: 11.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "open_een",
    cx: 11.5,
    cy: 14.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "open_een",
    cx: 11.5,
    cy: 17.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "open_een",
    cx: 11.5,
    cy: 20.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "open_een",
    d: "M20.5,12h-7c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h7c0.276,0,0.5,0.224,0.5,0.5 S20.776,12,20.5,12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "open_een",
    d: "M20.5,15h-7c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h7c0.276,0,0.5,0.224,0.5,0.5 S20.776,15,20.5,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "open_een",
    d: "M20.5,18h-7c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h7c0.276,0,0.5,0.224,0.5,0.5 S20.776,18,20.5,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "open_een",
    d: "M20.5,21h-7c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h7c0.276,0,0.5,0.224,0.5,0.5 S20.776,21,20.5,21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "open_een",
    d: "M23.5,30h-15C7.673,30,7,29.327,7,28.5v-25C7,2.673,7.673,2,8.5,2h1C9.776,2,10,2.224,10,2.5 S9.776,3,9.5,3h-1C8.224,3,8,3.225,8,3.5v25C8,28.775,8.224,29,8.5,29h15c0.276,0,0.5-0.225,0.5-0.5v-25C24,3.225,23.776,3,23.5,3 h-11C12.224,3,12,2.776,12,2.5S12.224,2,12.5,2h11C24.327,2,25,2.673,25,3.5v25C25,29.327,24.327,30,23.5,30z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "open_een",
    cx: 11.5,
    cy: 11.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "open_een",
    cx: 11.5,
    cy: 14.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "open_een",
    cx: 11.5,
    cy: 17.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "open_een",
    cx: 11.5,
    cy: 20.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "open_een",
    d: "M20.5,12h-7c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h7c0.276,0,0.5,0.224,0.5,0.5 S20.776,12,20.5,12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "open_een",
    d: "M20.5,15h-7c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h7c0.276,0,0.5,0.224,0.5,0.5 S20.776,15,20.5,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "open_een",
    d: "M20.5,18h-7c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h7c0.276,0,0.5,0.224,0.5,0.5 S20.776,18,20.5,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "open_een",
    d: "M20.5,21h-7c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h7c0.276,0,0.5,0.224,0.5,0.5 S20.776,21,20.5,21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "open_een",
    d: "M23.5,30h-15C7.673,30,7,29.327,7,28.5v-25C7,2.673,7.673,2,8.5,2h1C9.776,2,10,2.224,10,2.5 S9.776,3,9.5,3h-1C8.224,3,8,3.225,8,3.5v25C8,28.775,8.224,29,8.5,29h15c0.276,0,0.5-0.225,0.5-0.5v-25C24,3.225,23.776,3,23.5,3 h-11C12.224,3,12,2.776,12,2.5S12.224,2,12.5,2h11C24.327,2,25,2.673,25,3.5v25C25,29.327,24.327,30,23.5,30z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialLedgerReport);
export default __webpack_public_path__ + "static/media/Material-Ledger-Report.c4c7b611294dd8d3bacf26b95c2e9cfa.svg";
export { ForwardRef as ReactComponent };